module.exports = __webpack_public_path__ + "img/25_26.58071184.png";